/*
 * File: TalentDetails.tsx
 * Project: a-a
 * File Created: Monday, 6th October 2025 10:39:18 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 23rd October 2025 10:52:13 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Chip, Divider, Skeleton, Typography, useTheme } from '@mui/material';
import zeplinColor from '../../../../theme/Color';

const TalentDetails = ({ details, loading }: { details: any; loading: boolean }) => {
  const theme = useTheme();
  return (
    <>
      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '18px', xl: '24px' },
          padding: { xs: '0px 20px 0px 20px', xl: '0px 24px 0px 24px' },
        }}
      >
        <Typography variant='responsiveHeading3'>Personal Details</Typography>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Account name
          </Typography>

          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.accountName}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Agency
          </Typography>

          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.agency ?? 'N/A'}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Birthdate
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.birthdate ?? 'N/A'}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            IMDBPro
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.imdbPro ?? 'N/A'}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Type
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.type ?? 'N/A'}
            </Typography>
          )}
        </Box>
      </Box>
      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '18px', xl: '24px' },
          padding: { xs: '0px 20px 0px 20px', xl: '0px 24px 0px 24px' },
        }}
      >
        <Typography variant='responsiveHeading3'>Contact Details</Typography>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Phone
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.phone ?? 'N/A'}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Mobile
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.mobile ?? 'N/A'}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Email
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.email ?? 'N/A'}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Personal email
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.personalEmail ?? 'N/A'}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Mailing address
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.mailingAddress ? '' : 'N/A'}
              {details?.mailingAddress?.street ? `${details?.mailingAddress.street},` : ''}
              {details?.mailingAddress?.city ? `${details?.mailingAddress.city},` : ''}
              {details?.mailingAddress?.country ? `${details?.mailingAddress?.country},` : ''}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Billing address
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.billingAddress ? '' : 'N/A'}
              {details?.billingAddress?.street ? `${details?.billingAddress.street},` : ''}
              {details?.billingAddress?.city ? `${details?.billingAddress.city},` : ''}
              {details?.billingAddress?.country ? `${details?.billingAddress?.country},` : ''}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Bio
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.bio ?? 'N/A'}
            </Typography>
          )}
        </Box>
      </Box>

      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '18px', xl: '24px' },
          padding: { xs: '0px 20px 20px 20px', xl: '0px 24px 20px 24px' },
        }}
      >
        <Typography variant='responsiveHeading3'>Additional Information</Typography>
        <Box sx={{ display: 'flex', gap: '48px' }}>
          <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
            Loan out company
          </Typography>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
              {details?.loanOutCompany ?? 'N/A'}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default TalentDetails;
